import { createContext, ReactNode, useContext } from 'react';
import { AppTableNewProps } from '../..';

type AppTableContextProps<TData> = AppTableNewProps<TData>;

export const AppTableContext = createContext<
  AppTableContextProps<unknown> | undefined
>(undefined);

export const AppTableProvider = <TData,>({
  children,
  ...props
}: AppTableContextProps<TData> & {
  children: ReactNode | ReactNode[];
}) => {
  return (
    <AppTableContext.Provider
      value={props as unknown as AppTableContextProps<unknown>}
    >
      {children}
    </AppTableContext.Provider>
  );
};

export const useAppTableContext = <TData,>(): AppTableContextProps<TData> => {
  const context = useContext(AppTableContext) as AppTableContextProps<TData>;

  if (!context) {
    throw new Error(
      'useAppTableContext must be used within a AppTableProvider',
    );
  }

  return context as AppTableContextProps<TData>;
};
